<template>
  <div>
    <v-dialog
      max-width="550px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Assets Statuses
          <v-spacer></v-spacer>
          <v-text-field
            dense
            clearable
            hide-details
            v-model="search"
            append-icon="mdi-magnify"
            label="Search status"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-data-table
            dense
            :headers="assets_statuses_headers"
            :items="assets_statuses"
            :items-per-page="10"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, -1]
            }"
          >
            <template v-slot:[`item.Actions`]="{ item, index }">
              <v-btn icon small
                @click.prevent="getAssetsStatusDetailsById(item.Status_ID)"
                color="primary"
              >
                <v-icon>mdi-pencil-circle</v-icon>
              </v-btn>
              <v-btn icon small
                color="red darken-2"
                :disabled="!item.Can_Delete"
                @click.prevent="deleteAssetsStatus(item.Status_ID, index)"
              >
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="success" @click="addNewAssetsStatus">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="deleteAssetsStatusDialog"
      v-model="deleteAssetsStatusDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="removeAssetsStatus"
      @onCancelClick="deleteAssetsStatusDialog = false"
      @onCloseClick="deleteAssetsStatusDialog = false"
    />
    <AssetsStatusEditor
      v-model="showAssetsStatusEditor"
      :addMode="addMode"
      :currentAssetsStatus="selectedAssetsStatus"
      :assets_statuses="assets_statuses"
    ></AssetsStatusEditor>
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'AssetsStatusManager',
  props: {
    value: {
      required: false
    },
    assets_statuses: {
      required: false,
      default: () => []
    }
  },
  components: {
    AssetsStatusEditor: () => import('@/components/assets/AssetsStatusEditor.vue'),
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  data () {
    return {
      addMode: false,
      showEditor: false,
      selectedAssetsStatus: {},
      search: '',
      deleteAssetsStatusDialog: false,
      deletedIndex: null,
      assets_statuses_headers: [
        {
          text: 'Status',
          value: 'Status',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: '',
          value: 'Actions',
          cellClass: 'px-2 text-no-wrap',
          class: 'px-2 text-no-wrap',
          width: '5%',
          sortable: false
        }
      ]
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    showAssetsStatusEditor: {
      get () {
        return this.showEditor
      },
      set (value) {
        this.showEditor = value
      }
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  mounted () {
  },
  methods: {
    getAssetsStatusDetailsById (id) {
      this.axios.get(`/api/asset_status/${id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.selectedAssetsStatus = res.data[0]
        this.addMode = false
        this.showAssetsStatusEditor = true
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    addNewAssetsStatus () {
      this.selectedAssetsStatus = {
        Status_ID: null,
        Status: ''
      }
      this.addMode = true
      this.showAssetsStatusEditor = true
    },
    deleteAssetsStatus (id, index) {
      this.selectedAssetsStatus.Status_ID = id
      this.deletedIndex = index
      this.deleteAssetsStatusDialog = true
    },
    removeAssetsStatus () {
      this.axios.delete(`/api/asset_status/${this.selectedAssetsStatus.Status_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.deleteAssetsStatusDialog = false
        const idx = this.assets_statuses.findIndex(x => x.Status_ID === this.selectedAssetsStatus.Status_ID)
        if (idx !== -1) {
          this.assets_statuses.splice(idx, 1)
        }
        this.$store.dispatch('setSuccess', { successMsg: 'Status successfully deleted' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
